import React from 'react';
import { Col, Row } from 'react-bootstrap';
import orn from './../../../assets/images/ornament.svg';
import css from './About.module.css';
import aimg1 from './../../../assets/images/about/a1.jpg';
import aimg2 from './../../../assets/images/about/a2.jpg';
import aimg3 from './../../../assets/images/about/a3.jpg';
import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import { useForm } from 'antd/es/form/Form';
function About(props) {
    let [form] = useForm();
    let onFinish = (v) => {
        console.log(v);
        axios.post('messages', v).then(res => {
            form.resetFields();
            message.success("Xabar muvaffaqiyatli yuborildi!!!");
        })
    }


    return (
        <>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <h1>Biz haqqimizda</h1>
            </div>
            <Row>
                <Col md={6}>
                    <div style={{ position: 'relative', height: '100%' }}>
                        <img className={css.aboutimg} src={aimg1} alt="Kitobhon tizimi haqida" />
                        <img className={css.aboutimg} src={aimg3} alt="Kitobhon tizimi haqida" />
                        <img className={css.aboutimg} src={aimg2} alt="Kitobhon tizimi haqida" />

                    </div>
                </Col>
                <Col md={6}>
                    <h2>Tizim haqida</h2>
                    <p>
                        Mazkur Platforma o’quvchiga qulayliklar yaratish maqsadida turli sohalarga oid elektron kitoblar, audio kitoblar, video va turli qiziqarli test savollari bilan boyitilgan. Mahallalarda, oilalarda yoshlar ma’naviyatini yuksaltirish, ularni kitobxon qilib tarbiyalash, adabiyotlarni to’gri tanlay olishlari uchun yo’nalish ko’rsatish, shuningdek ota-onalarga oila haqida ilmiy kitoblar orqali ko’rsatma berish, ularning bo’sh vaqtlarini mazmunli tashkil etish, oila birdamligini oilaviy kitob o’qish orqali ta’minlash maqsadida mazkur Platforma tashkil etildi.
                        Kitob turli-tuman qarashlar, g‘oyalar, yashab o‘tgan va hozirda mavjud tafakkur sohiblarining  fikrlari, ibratlari, dil kechinmalarini saqlash, yig‘ish va tarqatish uchun xizmat qiladi. Kitob aynan mana shu jihatlari bilan qadrlidir.
                        Oilalarda ota-onalar internet saytlari orqali farzandlari bilan birgalikda kitoblarni tanlashlari, birga o‘qish yoki o‘zlari o‘qigan mashhur asarlarning jarayonlari xususida so‘zlab berishlari orqali oilada yoshlarni kitob o‘qishga qiziqishlarini shakllantirishga, kitob orqali ta’lim-tarbiya jarayonlarini tashkil etishga, yosh va psixofiziologik xususiyatlarini hisobga olgan holda ularda kitob bilan ishlash, kitobning mazmunini idrok etish ko‘nikmasini rivojlantirish borasida eng ishonchli platforma familybook.uz

                    </p>
                    <ul style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <li>Onlayn kitob o'qish platformasi o'quvchilarga kitoblarni smartfon, planshet yoki kompyuter orqali o'qish imkonini beradi. Bu esa kitobxonning har qanday joyda va har qanday vaqtda o'qishiga sharoit yaratadi. Shuningdek, raqamli kitoblar bir necha gramm vaznga ega bo'lib, o'quvchiga ko'p hajmli kitoblarni tashishdan qutqaradi;</li>
                        <li>Mazkur platformada turli janrlardagi kitoblar mavjud bo'lib, o'quvchi o'z qiziqishlariga mos keladigan asarni topishi mumkin. Klassik adabiyot, ilmiy-fantastika, romantika, tarixiy kitoblar va boshqa ko'plab janrlar bo'yicha keng tanlov mavjud;</li>
                        <li>Onlayn kitob o'qish platformalarida kitob ichidagi so'zlar va iboralarni qidirish imkoniyati mavjud. Shuningdek, o'quvchi o'ziga yoqqan sahifalar yoki paragraflarni belgilab qo'yishi mumkin;</li>
                        <li>Mazkur platforma zamonaviy o'quvchilar uchun katta qulaylik va keng imkoniyatlar yaratadi. Bugungi kun texnologiyasining eng so’ngi yangiliklari bilan boyitilgan saytimizda Sun'iy intelekt yordamaidan foydalangan holda - Psihologik huquqiy, maishiy va boshqa masalalarda yordam olish imkoniyatlari mavjud bo’lib, unda o’quvchi o’zi qiziqqan harqanday mavzuga oid savollariga sun’iy intellekt orqali javob olishlari mumkin;</li>
                    </ul>
                </Col>
            </Row>
            <div className="page-intro" style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                marginTop: '60px',
                marginBottom: '40px',
            }}>
                <Form
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    form={form}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <h3>Murojaat yo'llash...</h3>
                    <Row>
                        <Col md={6}>
                            <Form.Item
                                label="FISH"
                                name="fullname"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Iltimos Familya ism sharifingizni kiriting!',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Telefon"
                                name="phone"
                            >
                                <Input type='tel'  />
                            </Form.Item>
                            <Form.Item
                                label="Email"
                                name="email"
                            >
                                <Input type='email' />
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <Form.Item name={'message'} label="Murojaat matni">
                                <Input.TextArea rows={6} />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">Yuborish</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>

        </>
    );
}

export default About;